export default __webpack_public_path__ + "static/media/3.60cfef45.png";